import { useTranslation } from "react-i18next";

import { useSoftphone } from "./SoftphoneProvider";
import { useSoftphoneStore } from "./store";

export function CallButton({
  phone,
  number,
  label,
}: {
  /** A `ContactPhone` pk. Prefer this: it is what puts the call on a timeline. */
  phone?: number;
  /** A hand-typed number, when no `ContactPhone` exists yet. */
  number?: string;
  label?: string;
}) {
  const { t } = useTranslation();
  const { start, isStarting } = useSoftphone();
  const active = useSoftphoneStore((state) => state.call);

  if (phone === undefined && !number) return null;

  return (
    <button
      type="button"
      // One call at a time: the `Device` holds a single leg.
      disabled={isStarting || active !== null}
      onClick={() =>
        void start({
          ...(phone !== undefined ? { phone } : {}),
          ...(number ? { number } : {}),
          ...(label ? { label } : {}),
        })
      }
      className="btn btn-primary px-3 py-1.5 text-sm"
    >
      {t("call.start")}
    </button>
  );
}
